import { FormConfig, SelectOption } from '@lbcamden/lib-react';
import { z } from 'zod';

import { newCaseSchema } from '~/common/schemas/cases';
import { ReferenceListType } from '~/common/types/data';
import { Person } from '~/common/types/people';
import { selectOptionValuesToNumbers } from '~/common/utils/data';

export type NewCaseFormValues = z.infer<typeof newCaseFormSchema>;

export const newCaseFormSchema = newCaseSchema
  .pick({
    leadOfficer: true,
    personId: true,
    demandCode: true,
  })
  .extend({
    details: z.string().min(3, 'Please provide more details'),
  });

export const peopleToSelectOptions = (people: Person[]): SelectOption<number>[] =>
  people.map((person) => ({
    id: String(person.personId),
    value: person.personId,
    label: person.fullName,
  }));

export const newCaseFormConfig = (
  people: Person[],
  referenceListSelectOptions: (type: ReferenceListType) => SelectOption[],
): FormConfig<NewCaseFormValues> => ({
  fieldConfigs: {
    leadOfficer: {
      readOnly: true,
    },
    personId: {
      label: 'Person',
      placeholder: 'Who is this case regarding?',
      selectOptions: peopleToSelectOptions(people),
    },
    demandCode: {
      label: 'Case type',
      placeholder: 'Search for the type',
      autocomplete: true,
      selectOptions: selectOptionValuesToNumbers(referenceListSelectOptions('LWP_DEMAND')),
    },
    details: {
      label: 'Case details',
      type: 'textarea',
    },
  },
});
